import React from 'react';
import styled from 'styled-components';

const ImageThumbnails = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  width: 90%;
  grid-gap: 0.5rem;
  margin: 0.5rem 0 0.5rem;
`;

const StyledThumbnail = styled.div`
  display: inline-block;
  vertical-align: top;
  cursor: pointer;
  border: 1px solid ${props => props.theme.colors.grey[200]};
  overflow: hidden;
  width: 48px;
  height: 48px;

  &[aria-selected='true'] {
    border: 2px solid ${props => props.theme.colors.grey[700]};
  }

  :focus {
    outline: none;
    border-color: ${props => props.theme.colors.feedback.focus};
  }
`;

type ThumbnailProps = React.HTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode;
  onSelect: () => void;
};

export const Thumbnail = ({ children, onSelect, ...props }: ThumbnailProps) => {
  const onKeyPress = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if ([' ', 'Enter'].includes(event.key)) {
      onSelect();
    }
  };

  return (
    <StyledThumbnail {...props} role="button" onClick={onSelect} onKeyPress={onKeyPress}>
      {children}
    </StyledThumbnail>
  );
};

export default ImageThumbnails;
